/**
 * Central configuration: every literal that used to be scattered through
 * components lives here under a name. Server-tunable values (upload cap,
 * poll intervals) are DEFAULTS — `src/lib/states.ts` overrides them from
 * `GET /api/meta` when the backend provides it.
 */

/* localStorage keys */
export const LS_LANG_KEY = "excel-engine.lang";
export const LS_PARAM_PREFIX = "excel-engine.param.";
export const LS_THEME_KEY = "excel-engine.theme";
export const LS_DENSITY_KEY = "excel-engine.density";
export const LS_CUSTOMER_KEY = "excel-engine.customer";

/* sessionStorage keys */
export const SS_AUDIT_CHAT_KEY = "excel-engine.audit.chat";

/* top-bar search */
export const SEARCH_DEBOUNCE_MS = 300;
export const SEARCH_MIN_CHARS = 2;

/* truncation / display lengths */
export const ID_SLICE_LEN = 8;
export const SHA_SLICE_LEN = 12;
export const ERROR_DETAIL_MAX_CHARS = 600;
export const PREFLIGHT_ERRORS_SHOWN = 6;
export const DATE_SLICE_LEN = 10; // YYYY-MM-DD
export const DATETIME_SLICE_LEN = 16; // YYYY-MM-DD HH:MM

/* run list */
export const RUNS_LIST_LIMIT = 100;

/** How often a tab tells the server it still edits its customer (the
 *  server forgets a holder silent for about twice this). */
export const LEASE_HEARTBEAT_MS = 20_000;

/* param form */
export const YEAR_MIN = 2000;
export const YEAR_MAX = 2100;

/* uploads */
export const XLSX_ACCEPT = ".xlsx,.xlsm";
export const DEFAULT_MAX_UPLOAD_BYTES = 209_715_200; // 200 MB, mirrors backend MAX_UPLOAD_BYTES

/* polling */
export const DEFAULT_POLL_MS = 2_000;
export const DEFAULT_STATS_POLL_MS = 30_000;
export const HEALTH_POLL_MS = 60_000;
export const APPROVALS_POLL_MS = 15_000;
/** Escalation schedule for job polling: base → … → cap. */
export const POLL_BACKOFF_STEPS_MS = [2_000, 5_000, 10_000];
/** Consecutive unchanged (or failed) polls before stepping up the schedule. */
export const POLL_BACKOFF_AFTER = 4;
